export default __webpack_public_path__ + "static/1092-030cb1c902dd58ed289d6f7ac974faae.gif";